export default {"src":"/_next/static/media/qrcode-color.0448f5ca.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};